import React from 'react';
import PageHeader from "../common/ui/pageheader"; // Reusable header component with title, subtitle & button

// MaterialHeading Component
// Props:
// - onAddClick: Function to handle "Add Material" button click
export default function MaterialHeading({ onAddClick }) {
  return (
    <PageHeader
      title="Add Material" // Main heading text
      subtitle="Here you can record arriving materials." // Sub-heading/description
      buttonText="Add Material" // Text displayed on the button
      onButtonClick={onAddClick} // Event handler when button is clicked
    />
  );
}
